import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M10 .399V31.6c-1.456-.2-2.727-.476-3.658-.83C4.176 29.927 2.82 28.328 2 26.91V5.088c.82-1.418 2.176-3.018 4.342-3.86C7.272.875 8.544.6 10 .4",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M6 6.667c1.84 0 3.333-1.045 3.333-2.334C9.333 3.045 7.841 2 6 2S2.667 3.045 2.667 4.333 4.159 6.667 6 6.667",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M2.692 4.042A8.8 8.8 0 0 1 4.48 2.256 4.5 4.5 0 0 1 6 2v2.333h3.333c0 1.289-1.492 2.334-3.333 2.334V4.333H2.667q0-.147.025-.29",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M6 5.333c.736 0 1.333-.447 1.333-1s-.597-1-1.333-1c-.737 0-1.333.448-1.333 1 0 .553.596 1 1.333 1",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M4.48 29.744a8.8 8.8 0 0 1-1.788-1.787 2 2 0 0 1-.026-.29c0-1.289 1.493-2.334 3.334-2.334s3.333 1.045 3.333 2.334C9.333 28.955 7.841 30 6 30a4.5 4.5 0 0 1-1.52-.256",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M2.667 27.667c0-1.289 1.492-2.334 3.333-2.334v2.334h3.333C9.333 28.955 7.841 30 6 30v-2.333z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M6 12.667c1.84 0 3.333-1.045 3.333-2.334C9.333 9.045 7.841 8 6 8s-3.333 1.045-3.333 2.333S4.159 12.667 6 12.667",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M5.333 8.047v4.573A4.1 4.1 0 0 1 4 12.2V8.467c.388-.204.84-.35 1.333-.42M8 8.467V12.2c-.388.204-.84.35-1.333.42V8.047c.492.07.945.216 1.333.42",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M6 11.333c1.105 0 2-.447 2-1s-.895-1-2-1-2 .448-2 1c0 .553.895 1 2 1",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M6 18c-1.841 0-3.333-.895-3.333-2S4.159 14 6 14c1.84 0 3.333.895 3.333 2S7.841 18 6 18m0-1.333c1.104 0 2-.299 2-.667s-.896-.667-2-.667-2 .299-2 .667.895.667 2 .667M6 24c1.84 0 3.333-1.045 3.333-2.333S7.841 19.333 6 19.333s-3.333 1.045-3.333 2.334C2.667 22.955 4.159 24 6 24",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M6 21.333A.667.667 0 1 0 6 20a.667.667 0 0 0 0 1.333m-2 1A.667.667 0 1 0 4 21a.667.667 0 0 0 0 1.333m2 1A.667.667 0 1 0 6 22a.667.667 0 0 0 0 1.333m2-1A.667.667 0 1 0 8 21a.667.667 0 0 0 0 1.333",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M6 28.667c.736 0 1.333-.448 1.333-1 0-.553-.597-1-1.333-1-.737 0-1.333.447-1.333 1s.596 1 1.333 1",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M13.621 10.379a5.333 5.333 0 0 0 7.424-7.424 5.333 5.333 0 1 1-7.424 7.424m2.836-6.999-.433.571-.015-.716L15.333 3l.676-.235.015-.716.433.57.685-.207-.409.588.41.588zm0 2.667-.433.57-.015-.715-.676-.235.676-.235.015-.716.433.57.685-.207-.409.588.41.587z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "m16.457 8.714-.433.57-.015-.716-.676-.235.676-.235.015-.716.433.57.685-.206-.409.587.41.588zm-2.667-2-.432.57-.015-.716-.676-.235.676-.235.015-.716.432.57.686-.206-.41.587.41.588zm5.334-1.334-.433.571-.014-.716L18 5l.677-.235.014-.716.433.57.685-.207L19.4 5l.41.588z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagTkm = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagTkm_default = SvgFlagTkm;

export { FlagTkm_default as default };
